<template>
  <div>
    <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
        @submit="handleSubmit"
    >
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
          <a-form-item>
            <span class="required" slot="label">申请人</span>
            <a-input :value="showApplicant" disabled/>
          </a-form-item>
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
          <a-form-item>
            <span class="required" slot="label">申请部门</span>
            <a-input :value="showDepartment" disabled/>
          </a-form-item>
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
          <a-form-item label="申请日期">
            <a-date-picker
                v-if="!isDetail"
                style="width: 100%"
                v-decorator="[
                'applyDate',
                { rules: [{ required: true, message: '请选择！' }] },
              ]"
            />
            <a-input v-else :value="detailData.applyDate" disabled/>
          </a-form-item>
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
          <a-form-item label="类别">
            <a-select
                v-if="!isDetail"
                @change="onCategoryChange"
                v-decorator="[
                'purchaseCategory',
                { rules: [{ required: true, message: '请选择类别！' }] },
              ]"
            >
              <a-select-option
                  v-for="item in categoryList"
                  :key="item.value"
                  :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
            <a-input v-else :value="categoryLabel" disabled/>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- ===== 酒水清单 ===== -->
      <template v-if="selectedCategory === 'wine'">
        <div class="between">
          <div class="title">酒水清单</div>
          <WineAdd v-if="!isDetail" @add="addItem"/>
        </div>

        <a-table bordered :dataSource="list" :pagination="false" :columns="liquorColumns">
          <template slot="unitPriceCol" slot-scope="text">
            <span style="color: #1890ff">{{ text }}</span>
          </template>
          <template slot="actionCol" slot-scope="text, record, index">
            <a href="#" class="danger" @click.prevent="remove(index)">移除</a>
          </template>
        </a-table>
      </template>

      <!-- ===== 礼品清单 ===== -->
      <template v-else-if="selectedCategory === 'gift'">
        <div class="between">
          <div class="title">礼品清单</div>
          <GiftAdd v-if="!isDetail" @add="addItem"/>
        </div>

        <a-table bordered :dataSource="list" :pagination="false" :columns="giftColumns">
          <template slot="unitPriceCol" slot-scope="text">
            <span style="color: #1890ff">{{ text }}</span>
          </template>
          <template slot="actionCol" slot-scope="text, record, index">
            <a href="#" class="danger" @click.prevent="remove(index)">移除</a>
          </template>
        </a-table>
      </template>

      <!-- ===== 物料清单 ===== -->
      <template v-else-if="selectedCategory === 'material'">
        <div class="between">
          <div class="title">物料清单</div>
          <MaterialAdd v-if="!isDetail" @add="addItem"/>
        </div>

        <a-table
            bordered
            :dataSource="list"
            :pagination="false"
            :columns="materialColumns"
        >
          <template slot="price" slot-scope="text">
            <span style="color: #1890ff">{{ text }}</span>
          </template>
          <template slot="amount" slot-scope="text, record">
            <span>{{ text || record.num || record.count || '—' }}</span>
          </template>
          <template slot="action" slot-scope="text, record, index">
            <a href="#" class="danger" @click.prevent="remove(index)">移除</a>
          </template>
        </a-table>
      </template>

      <div class="center">
        <a-space>
          <a-button v-if="!isDetail" htmlType="submit" type="primary" :loading="loading">提交</a-button>
          <a-button @click="handleClose">关闭</a-button>
        </a-space>
      </div>
    </a-form>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import WineAdd from "./components/wine-add.vue";
import GiftAdd from "./components/gift-add.vue";
import MaterialAdd from "./components/material-add.vue";
import moment from "moment";

export default {
  name: "PurchaseMaterialsForm",

  components: {WineAdd, GiftAdd, MaterialAdd},

  props: {
    // 详情数据（用于查看详情）
    detailData: {type: Object, default: null},
    // 编辑时的原始数据（用于编辑模式）
    editData: {type: Object, default: null},
  },

  data() {
    return {
      form: this.$form.createForm(this),
      list: [],
      loading: false,
      categoryList: [
        {label: '酒水', value: 'wine'},
        {label: '礼品', value: 'gift'},
        {label: '物料', value: 'material'},
      ],
      selectedCategory: '',
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),

    // 是否为详情模式
    isDetail() {
      return !!this.detailData;
    },

    // 原始数据（编辑模式用 editData，添加模式用 null）
    sourceData() {
      return this.editData || this.detailData;
    },

    categoryLabel() {
      const cat = this.categoryList.find((item) => item.value === this.selectedCategory);
      return cat ? cat.label : this.selectedCategory;
    },

    showApplicant() {
      if (this.sourceData) return this.sourceData.applicantName;
      return this.user.userName;
    },

    showDepartment() {
      if (this.sourceData) return this.sourceData.departmentName;
      return this.department.deptUniqueName;
    },

    liquorColumns() {
      const cols = [
        {title: "酒水品名", dataIndex: "name", ellipsis: true},
        {title: "类型", dataIndex: "typeInvName", ellipsis: true},
        {title: "子类型", dataIndex: "typeSubName", ellipsis: true},
        {title: "单位", dataIndex: "unitName", align: "center", ellipsis: true},
        {title: "单价(元)", dataIndex: "unitPrice", align: "center", scopedSlots: {customRender: "unitPriceCol"}, ellipsis: true},
        {title: "数量", dataIndex: "quantity", align: "center", ellipsis: true},
      ];
      if (!this.isDetail) {
        cols.push({title: "操作", align: "center", width: 100, scopedSlots: {customRender: "actionCol"}});
      }
      return cols;
    },

    giftColumns() {
      const cols = [
        {title: "礼品名", dataIndex: "name", ellipsis: true},
        {title: "类型", dataIndex: "typeInvName", ellipsis: true},
        {title: "子类型", dataIndex: "typeSubName", ellipsis: true},
        {title: "单位", dataIndex: "unitName", align: "center", ellipsis: true},
        {title: "单价(元)", dataIndex: "unitPrice", align: "center", scopedSlots: {customRender: "unitPriceCol"}, ellipsis: true},
        {title: "数量", dataIndex: "quantity", align: "center", ellipsis: true},
      ];
      if (!this.isDetail) {
        cols.push({title: "操作", align: "center", width: 100, scopedSlots: {customRender: "actionCol"}});
      }
      return cols;
    },

    materialColumns() {
      const cols = [
        {title: "分类", dataIndex: "category", ellipsis: true},
        {title: "商品名称", dataIndex: "name", ellipsis: true},
        {title: "规格型号", dataIndex: "spec", ellipsis: true},
        {title: "颜色", dataIndex: "color", ellipsis: true},
        {title: "单位", dataIndex: "unit", align: "center", ellipsis: true},
        {title: "单价(元)", dataIndex: "price", align: "center", scopedSlots: {customRender: "price"}, ellipsis: true},
        {title: "申领数量", dataIndex: "amount", align: "center", scopedSlots: {customRender: "amount"}, ellipsis: true},
        {title: "备注", dataIndex: "remark", ellipsis: true},
      ];
      if (!this.isDetail) {
        cols.push({title: "操作", align: "center", width: 100, scopedSlots: {customRender: "action"}});
      }
      return cols;
    },
  },

  mounted() {
    if (this.sourceData) {
      this.initFormData();
    } else {
      this.form.setFieldsValue({
        applyDate: moment(),
      });
    }
  },

  methods: {
    // 初始化表单数据
    initFormData() {
      const data = this.sourceData;

      // 设置表单值
      if (!this.isDetail) {
        this.form.setFieldsValue({
          applyDate: data.applyDate ? moment(data.applyDate) : moment(),
          purchaseCategory: data.purchaseCategory || undefined,
        });
      }

      // 解析清单数据，兼容字符串和数组格式
      let listData = [];

      if (data.materialsList) {
        if (typeof data.materialsList === 'string') {
          try {
            listData = JSON.parse(data.materialsList);
          } catch (e) {
            console.error('materialsList JSON parse error:', e);
          }
        } else if (Array.isArray(data.materialsList)) {
          listData = data.materialsList;
        }
      } else if (data.subList) {
        if (typeof data.subList === 'string') {
          try {
            listData = JSON.parse(data.subList);
          } catch (e) {
            console.error('subList JSON parse error:', e);
          }
        } else if (Array.isArray(data.subList)) {
          listData = data.subList;
        }
      }

      this.list = Array.isArray(listData) ? listData.map((item) => ({...item})) : [];

      // 设置类别
      this.selectedCategory = data.purchaseCategory
          || (this.list.length > 0 ? this.list[0].typeInv : '')
          || '';
    },

    /** 类别切换 */
    onCategoryChange(value) {
      this.selectedCategory = value || '';
      this.list = [];
    },

    /** 子组件添加回调 */
    addItem(item) {
      this.list.push(item);
    },

    remove(index) {
      this.list.splice(index, 1);
    },

    // 构建提交数据
    buildPayload(values) {
      const payload = {
        applicantId: this.sourceData?.applicantId || this.user.uuid,
        applicantName: this.sourceData?.applicantName || this.user.userName,
        departmentId: this.sourceData?.departmentId || this.department.deptId,
        departmentName: this.sourceData?.departmentName || this.department.deptUniqueName,
        applyDate: values.applyDate ? values.applyDate.format("YYYY-MM-DD") : "",
        purchaseCategory: values.purchaseCategory || "",
      };

      if (values.purchaseCategory === 'material') {
        payload.subList = this.list.map((item) => ({
          name: item.name,
          spec: item.spec,
          color: item.color,
          unit: item.unit,
          price: item.price,
          count: item.amount,
          remark: item.remark,
          category: item.category,
        }));
      } else {
        payload.subList = this.list.map((item) => ({
          name: item.name,
          materialId: item.materialId,
          typeInv: item.typeInv,
          typeInvName: item.typeInvName,
          typeSub: item.typeSub,
          typeSubName: item.typeSubName,
          unit: item.unit,
          unitName: item.unitName,
          unitPrice: item.unitPrice,
          quantity: item.quantity,
        }));
      }

      return payload;
    },

    // 验证并获取表单数据
    validateAndGetData(callback) {
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        if (this.list.length === 0) {
          this.$message.error("请添加采购物品");
          return;
        }
        const payload = this.buildPayload(values);
        callback(payload);
      });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.validateAndGetData((payload) => {
        this.$emit('submit', payload);
      });
    },

    handleClose() {
      this.$emit('close');
    },

    // 外部调用：设置加载状态
    setLoading(loading) {
      this.loading = loading;
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}

.center {
  margin-top: 40px;
  text-align: center;
}

.danger {
  color: #f5222d;
}

.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>